<div id="wait" *ngIf="loading || saving">
	<mat-spinner></mat-spinner>
</div>
<div class="row">
	<div class="col-md-12" style="display: flex; gap: 16px;">
		<div class="tab" [ngClass]="{'activeTab': subTab === 'Clinical'}"
			(click)="subTab = 'Clinical'; showHistory=false">
			<div class="tabContent">Clinical</div>
		</div>
		<div class="tab" [ngClass]="{'activeTab': subTab === 'Emotional'}" (click)="subTab = 'Emotional';">
			<div class="tabContent">Emotional</div>

		</div>
	</div>
</div>

<hr style="border: none; height: 1px; background-color: #D8D8D8; width: 97%; margin-top: 12px;" />

<div class="row mt-4" *ngIf="subTab === 'Clinical' && !showHistory">
	<ng-container *ngFor="let section of getVisibleGoalSections()">
		<div style="flex: auto;">
			<div class="col-md-12 mt-4"
				style="display: flex; align-items: center; justify-content: space-between; gap: 16px;">
				<div>
					<img class="img" src={{section.icon}} />&nbsp;&nbsp; <label
						class="label">{{section.title}}</label>&nbsp;
					&nbsp;<img class="img1" src="/assets/img/cir.png" />
				</div>
				<div style="display: flex; flex-direction: column;">
					<label class="goalLabel pillarLabel">Select Pillar</label>
					<select class="inputField" style="min-width: 350px;" [(ngModel)]="selectedPillar">
						<option *ngFor="let option of pillarOptions" [ngValue]="option.value">{{option.label}}</option>
					</select>
				</div>
			</div>
			<div *ngFor="let goal of section.goals">
				<div class="col-md-12 mt-4 goal-row">
					<div class="goal-title">
						<label class="labelReport">{{goal.label}}</label>
					</div>
					<div class="goal-actions">
						<button class="historyBtn" type="button" (click)="viewGoalHistory(goal, section)">Show
							History</button>
						<!-- <button class="btnGoal1" (click)="markComplete(goal.key)">{{completeText}}</button> -->
						<button class="editSave" (click)="handleSave(goal.key)"
							*ngIf="!getDisabledPropAsAny(goal.key)">Save</button>
						<button class="editSave" (click)="handleEdit(goal.key)"
							*ngIf="getDisabledPropAsAny(goal.key)">Edit</button>
					</div>
				</div>
				<div class="col-md-12">
					<label class="goalLabel">{{goal.description}}</label>
				</div>
				<div class="col-md-12" *ngIf="getValidationMessage(goal.key)" style="margin-top: 8px;">
					<span style="color: #d32f2f; font-size: 14px; font-family: 'Urbanist', sans-serif;">
						{{getValidationMessage(goal.key)}}
					</span>
				</div>
				<div class="col-md-12" *ngIf="isScoreValueExceeded(goal.key)" style="margin-top: 8px;">
					<span style="color: #d32f2f; font-size: 14px; font-family: 'Urbanist', sans-serif;">
						Score value must be less than or equal to 100
					</span>
				</div>
				<div class="col-md-12 goal-controls">
					<input type="text" class="inputField goalDescriptionField"
						[ngClass]="{'field-error': hasFieldError(goal.key, 'description')}"
						[ngModel]="getClinicalGoalDescription(goal.key)"
						(ngModelChange)="setClinicalGoalDescription(goal.key, $event)" 
						placeholder="Goal Description"
						[disabled]="getDisabledPropAsAny(goal.key)" />
					<ng-container [ngSwitch]="goal.key">
						<select *ngSwitchCase="'bedTime'" class="inputField" 
							[ngClass]="{'field-error': hasFieldError(goal.key, 'value')}"
							[ngModel]="getClinicalGoalValue(goal.key)"
							(ngModelChange)="setClinicalGoalValue(goal.key, $event)"
							[disabled]="getDisabledPropAsAny(goal.key)">
							<option value="" disabled>Select bed time</option>
							<option *ngFor="let option of bedTimeOptions" [ngValue]="option">{{option}}</option>
						</select>
						<input *ngSwitchDefault type={{goal.inputType}} class="inputField"
							[ngClass]="{'field-error': hasFieldError(goal.key, 'value') || isScoreValueExceeded(goal.key)}"
							[ngModel]="getClinicalGoalValue(goal.key)"
							(ngModelChange)="setClinicalGoalValue(goal.key, $event)" placeholder="Enter Value"
							[disabled]="getDisabledPropAsAny(goal.key)"
							[attr.max]="isScoreGoal(goal.key) ? 100 : null" />
					</ng-container>
					<mat-form-field class="customDate" [ngClass]="{'field-error': hasFieldError(goal.key, 'dates')}">
						<mat-label>Enter dates</mat-label>
						<mat-date-range-input [rangePicker]="picker" [min]="getMinStartDate(goal.key)">
							<input matStartDate placeholder="Start date" [(ngModel)]="getDatesPropAsAny(goal.key)[0]"
								(dateChange)="onGoalDateChange(goal.key)"
								[disabled]="getDisabledPropAsAny(goal.key) || isStartDateDisabled(goal.key)">
							<input matEndDate placeholder="End date" [(ngModel)]="getDatesPropAsAny(goal.key)[1]"
								(dateChange)="onGoalDateChange(goal.key)"
								[min]="getDatesPropAsAny(goal.key)[0]" [disabled]="getDisabledPropAsAny(goal.key)">
						</mat-date-range-input>
						<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="picker"
							[disabled]="getDisabledPropAsAny(goal.key)"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>
					</mat-form-field>
					<div class="custom-status-dropdown">
						<div class="status-dropdown-header" (click)="toggleGoalStatusDropdown(goal.key)"
							[class.disabled]="getDisabledPropAsAny(goal.key)"
							[class.field-error]="hasFieldError(goal.key, 'status')">
							<span *ngIf="!getStatusForGoal(goal.key)" class="status-placeholder">Select goal
								status</span>
							<span *ngIf="getStatusForGoal(goal.key)" class="status-selected-pill" [ngClass]="{
									'status-in-progress-pill': getStatusForGoal(goal.key) === 'In Progress',
									'status-completed-pill': getStatusForGoal(goal.key) === 'Completed'
								}">
								{{getStatusForGoal(goal.key)}}
							</span>
							<span class="dropdown-arrow">▼</span>
						</div>
						<div class="status-dropdown-options" *ngIf="isGoalStatusDropdownOpen(goal.key)">
							<div *ngFor="let status of statusOptions" class="status-option-pill" [ngClass]="{
									'status-in-progress-pill': status.value === 'In Progress',
									'status-completed-pill': status.value === 'Completed',
									'status-disabled': status.value === 'Completed' && !areAllMilestonesCompleted(goal.key)
								}" 
								(click)="selectGoalStatus(goal.key, status.value)">
								{{status.label}}
							</div>
						</div>
					</div>
					<button type="button" class="addMilestoneBtn" *ngIf="getMilestonesForGoal(goal.key).length === 0"
						(click)="addMilestone(goal.key)" [disabled]="getDisabledPropAsAny(goal.key)">Add
						Milestone</button>
				</div>
				<div class="progress-bar-container" *ngIf="getProgressForGoal(goal.key) !== null">
					<label class="progress-label">Task Completion Percentage</label>
					<div class="progress-bar-wrapper">
						<div class="progress-bar" [style.width.%]="getProgressForGoal(goal.key)"></div>
					</div>
					<span class="progress-percentage">{{getProgressForGoal(goal.key)}}%</span>
				</div>
				<ng-container *ngFor="let milestone of getMilestonesForGoal(goal.key); let i = index">
					<div class="milestone-row">
						<button type="button" class="milestonePublishBtn" (click)="toggleMilestonePublish(goal.key, i)"
							[disabled]="getDisabledPropAsAny(goal.key) || !isMilestonePublishEnabled(goal.key, i) || milestone.completed"
							*ngIf="!milestone.completed">
							<img [src]="milestone.isToBePublish ? '/assets/img/Property%201=eye%201.png' : '/assets/img/Property%201=hidden%201.png'"
								alt="Toggle visibility" />
						</button>
						<button type="button" class="milestoneToggleBtn" (click)="toggleMilestoneCompletion(goal.key, i)"
							[disabled]="getDisabledPropAsAny(goal.key)">
							<img [src]="milestone.completed ? '/assets/img/Property%201=checked%201.png' : '/assets/img/Property%201=Group%201410105298.png'"
								alt="Toggle completion" />
						</button>
						<input type="text" class="inputField milestoneInput" placeholder="Task Description"
							[ngClass]="{'field-error': hasMilestoneFieldError(goal.key, i, 'name')}"
							[(ngModel)]="milestone.name" [ngModelOptions]="{standalone: true}"
							(ngModelChange)="onMilestoneNameChange(goal.key, i, $event)"
							[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed">
						<ng-container [ngSwitch]="goal.key">
							<select *ngSwitchCase="'bedTime'" class="inputField milestoneValueField" 
								[ngClass]="{'field-error': hasMilestoneFieldError(goal.key, i, 'target')}"
								[ngModel]="getMilestoneTargetValue(goal.key, i)" [ngModelOptions]="{standalone: true}"
								(ngModelChange)="onMilestoneTargetChange(goal.key, i, $event)"
								[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed">
								<option value="" disabled>Select bed time</option>
								<option *ngFor="let option of bedTimeOptions" [ngValue]="option">{{option}}</option>
							</select>
							<input *ngSwitchCase="'fastingGlucose'" type="text" class="inputField milestoneValueField" 
								[ngClass]="{'field-error': hasMilestoneFieldError(goal.key, i, 'target')}"
								placeholder="Enter value"
								[ngModel]="getMilestoneTargetValue(goal.key, i)" [ngModelOptions]="{standalone: true}"
								(ngModelChange)="onMilestoneTargetChange(goal.key, i, $event)"
								[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed">
							<input *ngSwitchDefault type="number" class="inputField milestoneValueField" 
								[ngClass]="{'field-error': hasMilestoneFieldError(goal.key, i, 'target') || isMilestoneScoreValueExceeded(goal.key, i)}"
								placeholder="Enter value"
								[ngModel]="getMilestoneTargetValue(goal.key, i)" [ngModelOptions]="{standalone: true}"
								(ngModelChange)="onMilestoneTargetChange(goal.key, i, $event)"
								[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed"
								[attr.max]="isScoreGoal(goal.key) ? 100 : null">
						</ng-container>
						<mat-form-field class="milestoneDate" [ngClass]="{'field-error': hasMilestoneFieldError(goal.key, i, 'dates')}">
							<mat-label>Enter dates</mat-label>
							<mat-date-range-input [rangePicker]="milestonePicker" 
								[min]="getMilestoneMinDate(goal.key, i)"
								[max]="getMilestoneMaxDate(goal.key, i)">
								<input matStartDate placeholder="Start date" [(ngModel)]="milestone.startDate"
									[ngModelOptions]="{standalone: true}" 
									[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed"
									(dateChange)="onMilestoneDateChange(goal.key, i, 'start')">
								<input matEndDate placeholder="End date" [(ngModel)]="milestone.endDate"
									[ngModelOptions]="{standalone: true}" 
									[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed"
									[min]="milestone.startDate"
									(dateChange)="onMilestoneDateChange(goal.key, i, 'end')">
							</mat-date-range-input>
							<mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
							<mat-datepicker-toggle matIconSuffix [for]="milestonePicker"
								[disabled]="getDisabledPropAsAny(goal.key) || milestone.completed"></mat-datepicker-toggle>
							<mat-date-range-picker #milestonePicker></mat-date-range-picker>
						</mat-form-field>
						<button type="button" class="addMilestoneBtn" (click)="addMilestone(goal.key)"
							[disabled]="getDisabledPropAsAny(goal.key)"
							*ngIf="i === getMilestonesForGoal(goal.key).length - 1">Add Milestone</button>
						<button type="button" class="deleteMilestoneBtn" (click)="removeMilestone(goal.key, i)"
							[disabled]="getDisabledPropAsAny(goal.key)">
							<img src="/assets/img/trash%20(1)%203.png" alt="Delete" />
						</button>
					</div>
					<div class="col-md-12" *ngIf="isMilestoneScoreValueExceeded(goal.key, i)" style="margin-top: 4px; margin-bottom: 8px; margin-left: 80px;">
						<span style="color: #d32f2f; font-size: 14px; font-family: 'Urbanist', sans-serif;">
							Milestone {{i + 1}}: Score value must be less than or equal to 100
						</span>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>
</div>

<div *ngIf="subTab === 'Clinical' && showHistory">
	<div class="history-page-header mt-4">
		<div class="history-page-title">
			<img class="img" [src]="historySectionIcon" *ngIf="historySectionIcon" />&nbsp;&nbsp;
			<label class="label">{{historySectionTitle}}</label>&nbsp;
			&nbsp;<img class="img1" src="/assets/img/cir.png" />
		</div>
		<button class="historyBackBtn" type="button" (click)="closeHistoryView()">← Back to goals</button>
	</div>
	<div class="history-goal-header-row">
		<div class="history-goal-heading">
			<label class="labelReport">{{historyGoalLabel}}</label>
		</div>
		<div class="history-date-filter">
			<mat-form-field class="historyDate">
				<mat-label>Select date range</mat-label>
				<mat-date-range-input [rangePicker]="historyPicker">
					<input matStartDate placeholder="MM/DD/YYYY" [(ngModel)]="historyDateRange.start"
						[ngModelOptions]="{standalone: true}" (dateChange)="onHistoryStartChange()">
					<input matEndDate placeholder="MM/DD/YYYY" [(ngModel)]="historyDateRange.end"
						[ngModelOptions]="{standalone: true}" (dateChange)="onHistoryEndChange()"
						[min]="historyDateRange.start">
				</mat-date-range-input>
				<mat-datepicker-toggle matIconSuffix [for]="historyPicker"></mat-datepicker-toggle>
				<mat-date-range-picker #historyPicker></mat-date-range-picker>
			</mat-form-field>
		</div>
	</div>

	<div class="history-page-body">
		<div *ngIf="historyLoading" class="history-page-loader">
			<mat-spinner diameter="40"></mat-spinner>
		</div>
		<div *ngIf="!historyLoading">
			<p *ngIf="historyError" class="history-empty">{{historyError}}</p>
			<div *ngFor="let record of historyRecords" class="history-card page">
				<div class="history-row page">
					<div class="history-field">
						<label>Goal Description</label>
						<input class="inputField" [value]="record.description || record.goalDescription || '--'" disabled>
					</div>
					<div class="history-field">
						<label>Target</label>
						<input class="inputField" [value]="formatHistoryTarget(record)" disabled>
					</div>
					<div class="history-field">
						<label>Goal Duration</label>
						<input class="inputField" [value]="getHistoryDateRange(record)" disabled>
					</div>
					<div class="history-field">
						<label>Goal Completed Date</label>
						<input class="inputField" [value]="getHistoryCompletedDate(record)" disabled>
					</div>
					<div class="history-field">
						<label>Status</label>
						<input class="inputField" [value]="getHistoryStatus(record)" disabled>
					</div>
				</div>

				<div *ngIf="record.milestones?.length" class="history-milestone-section page">
					<label class="history-section-label">Milestones</label>
					<div class="history-milestone-row page" *ngFor="let milestone of record.milestones">
						<div class="history-icon">
							<img class="history-icon"
								[src]="milestone.isToBePublish ? '/assets/img/Property%201=eye%201.png' : '/assets/img/Property%201=hidden%201.png'"
								alt="Publish status icon" />
						</div>
						<div class="history-icon">
							<img class="history-icon"
								[src]="(milestone.completed || milestone.isCompleted) ? '/assets/img/Property%201=checked%201.png' : '/assets/img/Property%201=Group%201410105298.png'"
								alt="Completion status icon" />
						</div>
						<div class="history-field">
							<input class="inputField" [value]="milestone.taskName || milestone.name || '--'" disabled>
						</div>
						<div class="history-field">
							<input class="inputField" [value]="formatHistoryMilestoneTarget(milestone, record)" disabled>
						</div>
						<div class="history-field">
							<input class="inputField" [value]="formatMilestoneDateRange(milestone)" disabled>
						</div>
					</div>
				</div>
			</div>
			<p *ngIf="!historyError && historyRecords.length === 0" class="history-empty">No history available for this
				goal.</p>
		</div>
	</div>
</div>

<div class="row mt-4" *ngIf="subTab === 'Emotional'">
	<div class="col-md-12">
		<p>Emotional goals section coming soon.</p>
	</div>
</div>
<div style="height: 60px;"></div>